import { render, staticRenderFns } from "./AlertListItem.vue?vue&type=template&id=40df1062&scoped=true&lang=pug"
import script from "./AlertListItem.vue?vue&type=script&lang=ts"
export * from "./AlertListItem.vue?vue&type=script&lang=ts"
import style0 from "./AlertListItem.vue?vue&type=style&index=0&id=40df1062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df1062",
  null
  
)

export default component.exports